import { FC } from 'react';

import { ExternalLink, FeatureFlagDisplay } from '@app/components';
import { Feature, ShapeWithClassName } from '@app/constants';

import css from './CatalogLink.module.scss';

export const CatalogLink: FC<ShapeWithClassName> = ({ className }) => (
  <FeatureFlagDisplay
    flagToMatch={{ name: Feature.catalogLink }}
    renderOn={({ config: { href, label } }) => (
      <ExternalLink href={href} className={css.catalogLink}>
        {label}
      </ExternalLink>
    )}
  />
);
